//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      agree: this.check
    };
  },
  props: {
    check: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    agree: function(e) {
      this.$emit("update:check", e);
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/CCheckBox.vue